function configFiltro() {

    $('.filtro__link').click(function(e) {
        var $parent = $(this).parent();
        var aberto = $parent.attr('data-aberto');

        if(aberto == 'true') {
            $parent.attr('data-aberto', 'false');
        } else {
            $parent.attr('data-aberto', 'true');
        }
        
        e.preventDefault();
    });

}

export default configFiltro